import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { PackageResultCardProps } from '../types/bot.types';
import { AiFillStar } from 'react-icons/ai';
import { Button } from 'antd';
import { formatBotPrice } from './formatBotPrice';

const PackageResultCard: React.FC<PackageResultCardProps> = ({
  hotelName, hotelStars, mealPlan, nights, airline, departure, returnDate, totalPrice, currency, onSelect,
}) => {
  const t = useSelector((s: RootState) => (s.config.translations as any)?.bot);

  return (
    <div className="bot-result-card bot-result-card--package">
      <div className="bot-result-card__body">
        <div className="bot-result-card__name">{hotelName}</div>
        <div className="bot-result-card__stars">
          {Array.from({ length: Math.min(hotelStars, 5) }).map((_, i) => <AiFillStar key={i} color="#f5a623" />)}
        </div>
        <div className="bot-result-card__dates">✈️ {departure}{returnDate ? ` → ${returnDate}` : ''}</div>
        {nights !== undefined && (
          <div className="bot-result-card__meta">🌙 {nights} {t?.result?.nights ?? 'nights'}</div>
        )}
        {airline && <div className="bot-result-card__meta">✈️ {airline}</div>}
        {mealPlan && <span className="bot-result-card__badge">{mealPlan}</span>}
      </div>
      <div className="bot-result-card__footer">
        <div className="bot-result-card__price">{currency} {formatBotPrice(totalPrice)}</div>
        <Button size="small" type="primary" className="btn-style-5" onClick={onSelect}>
          {t?.result?.select ?? 'Select'}
        </Button>
      </div>
    </div>
  );
};

export default PackageResultCard;
